import { CloseCircleFilled } from '@ant-design/icons'
import { Button } from 'antd'
import { Link } from 'react-router'
import styled from '@emotion/styled'
import CenterContainer from '../components/CenterContainer'

const Heading = styled.h2`
  margin-top: 1em;
`

const TryButton = styled(Button)`
  margin-top: 2em;
  background-color: #FF691D;
  border-color: #FF691D;

  &:active,
  &:hover,
  &:focus {
    background-color: #FF691D;
    border-color: #FF691D;
  }
`

const NotFound = () => {
  return (
    <CenterContainer>
      <div>
        <CloseCircleFilled style={{ color: '#FF691D', fontSize: '4em' }} />
        <Heading>
          <b>ขออภัย</b> ไม่พบหน้าที่คุณต้องการ
        </Heading>
        <Link to="/">
          <TryButton shape="round" size="large" type="primary">
            ลองใหม่อีกครั้ง
          </TryButton>
        </Link>
      </div>
    </CenterContainer>
  )
}

export default NotFound
